var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopWatch = function SvgStopWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.553c3.866 0 7-3.17 7-7.079 0-3.91-3.134-7.079-7-7.079s-7 3.17-7 7.08c0 3.909 3.134 7.078 7 7.078Zm0-1.517c-3.038 0-5.5-2.49-5.5-5.562S4.962 3.912 8 3.912s5.5 2.49 5.5 5.562-2.462 5.562-5.5 5.562Zm.1-8.596c.331 0 .6.197.6.44v3.17s-.029.435-.6.435-.6-.435-.6-.435V6.88c0-.243.269-.44.6-.44Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.242.373a.758.758 0 1 1 0 1.517H5.758a.758.758 0 0 1 0-1.517h4.484ZM8.75 10.494a.75.75 0 0 1-1.5 0V6.938a.75.75 0 0 1 1.5 0v3.556ZM14.476 3.067a.765.765 0 0 1 0 1.073.744.744 0 0 1-1.06 0l-1.062-1.073a.765.765 0 0 1 0-1.073.744.744 0 0 1 1.061 0l1.06 1.073Z",
    fill: "currentColor"
  })));
};
export default SvgStopWatch;